<template>
  <b-modal
    :id="modalId"
    v-model="showModal"
    :title="'QR Code details for ' + brochure.title + ' (' + brochure.accessCode + ')'"
    size="lg"
    role="dialog"
    modal-class="regular"
    centered
    :ok-title="okTitle"
    :ok-only="okOnly"
    :ok-disabled="okDisabled"
  >
    <template slot="default">
      <div class="custom-modal-content">
        <div>
          <b-row>
            <b-col>
              <b-container>
                <p>
                  Provided information allows for a quick access to {{brochure.title}} brochure.
                </p>
              </b-container>
            </b-col>
          </b-row>
          <div v-if="brochure.qrCodeLocked">
            <hr style="margin-top: 0;" />
            <b-row>
              <b-col>
                <b-container>
                  <p>
                    This brochure is locked to the QR Code. In order for it to be placed correctly
                    the information about the physical size of the QR Code (when printed) is required.
                  </p>
                </b-container>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="4">
                <b-container class="label">Size (in millimeters):</b-container>
                <b-form-input
                  v-model="$v.qrCodeSize.$model"
                  placeholder="Enter the size"
                  class="modal-input"
                  v-bind:class="{ 'is-invalid': $v.qrCodeSize.$error }"
                  @input="updateQrCodeSize"
                ></b-form-input>
              </b-col>
            </b-row>
            <hr />
          </div>
          <b-row>
            <b-col>
              <b-container>
                <p>
                  Follow the link or scan the QR code to view:
                </p>

                <p>
                  <a :href="deepLinkUrl">
                    {{ deepLinkUrl }}
                  </a>
                </p>
              </b-container>
              <div class="qr-code-container">
                <div>
                  <img class="qr-code" :src="qrCodeImage" @click="openQrCodeWindow()"/>
                </div>
                <small class="qr-code-hint">click the QR Code for a printable version</small>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import * as harpraApi from '@/services/api.service'
import config from '@/config/backend.config'
import events from '@/enums/event-types'
import modals from '@/enums/modal-types'

import { required, integer } from 'vuelidate/lib/validators'

const DEFAULT_QR_CODE_SIZE = 50

export default {
  name: "QRCodeModal",
  props: {
    modalId: String,
    customDeepLinkUrl: String,
  },
  data() {
    return {
      okTitle: "Close",
      okDisabled: false,
      okOnly: true,
      showModal: false,
      brochure: this.createDefaultBrochure(),
      qrCodeImage: null,
      qrCodeSize: DEFAULT_QR_CODE_SIZE,
    }
  },
  computed: {
    deepLinkUrlBase() {
      return this.customDeepLinkUrl || config.deeplinkurl
    },
    deepLinkUrl() {
      let url = `${this.deepLinkUrlBase}?access_code=${this.brochure.accessCode}`

      if (this.brochure.qrCodeLocked) {
        if (this.$v.$anyError) {
          url += `&size=${DEFAULT_QR_CODE_SIZE}`
        } else {
          url += `&size=${this.qrCodeSize}`
        }
      }

      return url;
    }
  },
  methods: {
    createDefaultBrochure() {
      return {
        title: null,
        accessCode: null,
        qrCodeLocked: false,
      }
    },
    openQrCodeWindow() {
      // NOTE: this is a hackish way to open base64 URIs in the browser.
      var win = window.open()
      win.document.write('<iframe src="' + this.qrCodeImage + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>')
    },
    async onToggled(brochure) {
      this.brochure = brochure

      this.showModal = true

      await this.generateQrCode();
    },
    async generateQrCode() {
      let qrCode = await harpraApi.getQrCodeAsync(this.deepLinkUrl)

      this.qrCodeImage = 'data:image/png;base64,' + qrCode
    },
    async updateQrCodeSize() {
      await this.generateQrCode()
    },
    emptyBrochure() {
      return {
        title: null,
        accessCode: null,
      };
    }
  },
  validations: {
    qrCodeSize: {
      required,
      integer,
    },
  },
  created() {
    this.$eventBus.$on(events.toggleQrCodeModal, this.onToggled)
  },
  mounted() {
    this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
      if (modalId === modals.qrCodeModal) {
        this.brochure = this.createDefaultBrochure()

        this.qrCodeImage = null

        // NOTE: we don't reset 'this.qrCodeSize' here on purpose; we want it to be remembered between modal openings
      }
    })
  }
}
</script>
